export const RESET_SURGERY_STATE = "RESET_SURGERY_STATE";

export const START_GET_SURGERY_LIST = "START_GET_SURGERY_LIST";
export const SUCCESS_GET_SURGERY_LIST = "SUCCESS_GET_SURGERY_LIST";
export const ERROR_GET_SURGERY_LIST = "ERROR_GET_SURGERY_LIST";

export const START_CREATE_SURGERY = "START_CREATE_SURGERY";
export const SUCCESS_CREATE_SURGERY = "SUCCESS_CREATE_SURGERY";
export const ERROR_CREATE_SURGERY = "ERROR_CREATE_SURGERY";

export const START_UPDATE_SURGERY = "START_UPDATE_SURGERY";
export const SUCCESS_UPDATE_SURGERY = "SUCCESS_UPDATE_SURGERY";
export const ERROR_UPDATE_SURGERY = "ERROR_UPDATE_SURGERY";

export const START_GET_SINGLE_SURGERY = "START_GET_SINGLE_SURGERY";
export const SUCCESS_GET_SINGLE_SURGERY = "SUCCESS_GET_SINGLE_SURGERY";
export const ERROR_GET_SINGLE_SURGERY = "ERROR_GET_SINGLE_SURGERY";

export const START_DELETE_SURGERY = "START_DELETE_SURGERY";
export const SUCCESS_DELETE_SURGERY = "SUCCESS_DELETE_SURGERY";
export const ERROR_DELETE_SURGERY = "ERROR_DELETE_SURGERY";

export const START_GET_DRIVER_LIST = "START_GET_DRIVER_LIST";
export const SUCCESS_GET_DRIVER_LIST = "SUCCESS_GET_DRIVER_LIST";
export const ERROR_GET_DRIVER_LIST = "ERROR_GET_DRIVER_LIST";

export const START_WORKING_DAY_LIST = "START_WORKING_DAY_LIST";
export const SUCCESS_WORKING_DAY_LIST = "SUCCESS_WORKING_DAY_LIST";
export const ERROR_WORKING_DAY_LIST = "ERROR_WORKING_DAY_LIST";

export const START_GET_SURGERY_NOTE_LIST = "START_GET_SURGERY_NOTE_LIST";
export const SUCCESS_GET_SURGERY_NOTE_LIST = "SUCCESS_GET_SURGERY_NOTE_LIST";
export const ERROR_GET_SURGERY_NOTE_LIST = "ERROR_GET_SURGERY_NOTE_LIST";

export const START_CREATE_SURGERY_NOTE = "START_CREATE_SURGERY_NOTE";
export const SUCCESS_CREATE_SURGERY_NOTE = "SUCCESS_CREATE_SURGERY_NOTE";
export const ERROR_CREATE_SURGERY_NOTE = "ERROR_CREATE_SURGERY_NOTE";

export const START_UPDATE_SURGERY_NOTE = "START_UPDATE_SURGERY_NOTE";
export const SUCCESS_UPDATE_SURGERY_NOTE = "SUCCESS_UPDATE_SURGERY_NOTE";
export const ERROR_UPDATE_SURGERY_NOTE = "ERROR_UPDATE_SURGERY_NOTE";

export const START_GET_SINGLE_SURGERY_NOTE = "START_GET_SINGLE_SURGERY_NOTE";
export const SUCCESS_GET_SINGLE_SURGERY_NOTE =
  "SUCCESS_GET_SINGLE_SURGERY_NOTE";
export const ERROR_GET_SINGLE_SURGERY_NOTE = "ERROR_GET_SINGLE_SURGERY_NOTE";

export const START_DELETE_SURGERY_NOTE = "START_DELETE_SURGERY_NOTE";
export const SUCCESS_DELETE_SURGERY_NOTE = "SUCCESS_DELETE_SURGERY_NOTE";
export const ERROR_DELETE_SURGERY_NOTE = "ERROR_DELETE_SURGERY_NOTE";

export const START_GET_PRINT_SURGERY_LIST = "START_GET_PRINT_SURGERY_LIST";
export const SUCCESS_GET_PRINT_SURGERY_LIST = "SUCCESS_GET_PRINT_SURGERY_LIST";
export const ERROR_GET_PRINT_SURGERY_LIST = "ERROR_GET_PRINT_SURGERY_LIST";

export const START_UPDATE_FIELD_SURGERY = "START_UPDATE_FIELD_SURGERY";
export const SUCCESS_UPDATE_FIELD_SURGERY = "SUCCESS_UPDATE_FIELD_SURGERY";
export const ERROR_UPDATE_FIELD_SURGERY = "ERROR_UPDATE_FIELD_SURGERY";

export const START_CREATE_SURGERY_MULTI = "START_CREATE_SURGERY_MULTI";
export const SUCCESS_CREATE_SURGERY_MULTI = "SUCCESS_CREATE_SURGERY_MULTI";
export const ERROR_CREATE_SURGERY_MULTI = "ERROR_CREATE_SURGERY_MULTI";
